import { ReactNode } from 'react'
import { connect } from 'react-redux'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import { STEP_2_VALIDATION_URL } from '../../costants'

import Contractor from '../../components/people/contractor/Contractor'
import SiNo, { SiNoType, getBoolean, getSiNoValue } from '../../components/siNo/SiNo'
import { isValidPrivacy, getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'

import LoginRegister from '../../components/login/LoginRegister'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'
import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import { authFetch } from '../../libs/cookie/Cookie'

import Input from '../../libs/ui/inputs/Input'
import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import { DEVICES_PATTERN, isValid } from '../../libs/validation/stringRegex'
import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'
import { CompleteValidationError } from '../../libs/validation/completeValidationError'

import { cyberUpdate, cyberInitialState, CyberPageState, CyberPageProps } from './CyberPageSilce'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'

class CyberPage extends BasePage<CyberPageProps, CyberPageState> {

    constructor (props: any) {
        super(props)

        this.state = {
            ...cyberInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        // metodi specifici del preventivatore
        this.updateDispositiviConnessi = this.updateDispositiviConnessi.bind(this)
        this.updateAcquistiOnline = this.updateAcquistiOnline.bind(this)
        this.step2Validation = this.step2Validation.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()

        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }
    }

    render (): ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="cyber_form" >
                                <Pagination
                                    maxPagges={2}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={false}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={true}
                                        validatePage={this.step2Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}
                                        />

                                        <div className='col-12'>
                                            <Input 
                                                label="Quali dispositivi connessi ad internet possiedi (valori separati da ';')?"
                                                placeholder='es.: televisione;stampante;pc'
                                                id='dispositiviConnessi'
                                                name='dispositiviConnessi'
                                                type='text'
                                                value={this.state.dispositiviConnessi}
                                                regexp={DEVICES_PATTERN}
                                                errorDisplayMsg='Separa i dispositivi tramite il carattere ";"'
                                                error={this.state.dispositiviConnessiError}
                                                callback={this.updateDispositiviConnessi}
                                            />

                                            <SiNo 
                                                label='Fai acquisti online?'
                                                id='acquistiOnline'
                                                value={ getSiNoValue(this.state.acquistiOnline) }
                                                callback={this.updateAcquistiOnline}
                                                error={this.state.acquistiOnlineError}
                                            />
                                        </div>

                                        <NoMotorPrivacy 
                                            id='noMotorPrivacy'
                                            basePrivacy={this.state.noMotorPrivacy}
                                            isLogged={this.state.user !== undefined}
                                            callback={this.updateNoMotorPrivacy}
                                            error={this.state.noMotorPrivacyError}
                                        />
                                    </SinglePage>

                                </Pagination>
                            </form>

                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    // -- comuni
    getInitialState() {
        return cyberInitialState
    }

    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1Validation(),
            this.step2Validation(),
        ])
        .then ((responses) => {
            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }

            return {
                errorString: e,
                pageError: p
            }
        })
        .catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }

    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        } 
        else {
            let dispositiviConnessiErro = undefined
            let acquistiOnlineErro = undefined
            let noMotorPrivacyErro = undefined
            
            let global = undefined

            if ( errorString === 'DISPOSITIVI' ) {
                dispositiviConnessiErro = 'Indicare i dispositivi connessi a internet'
                global = dispositiviConnessiErro
            }
            else if ( errorString === 'ACQUISTI' ) {
                acquistiOnlineErro = 'Indicare se si fanno acquisti su internet'
                global = acquistiOnlineErro
            }
            else if ( errorString === 'PRIVACY' ) {
                noMotorPrivacyErro = 'Selezionare i campi obbligatori'
                global = noMotorPrivacyErro
            } 
            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                dispositiviConnessiError: dispositiviConnessiErro,
                acquistiOnlineError: acquistiOnlineErro,
                noMotorPrivacyError: noMotorPrivacyErro,
                globalError: global,
            })
        }
    }

    getSpecificDataForSubmit () {
        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),
            
            dispositiviConnessi: this.state.dispositiviConnessi ?? null,
            acquistiOnline: this.state.acquistiOnline ?? false
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    cyberUpdate (this.state)
                )
            }
        )
    }
    
    // -- solo del preventivatore
    private updateDispositiviConnessi (val: string | undefined) {
        this.saveStateAndRedux({
            dispositiviConnessi: val,
            dispositiviConnessiError: undefined
        })
    }

    private updateAcquistiOnline (val: SiNoType) {
        this.saveStateAndRedux({
            acquistiOnline: getBoolean(val),
            acquistiOnlineError: undefined
        })
    }

    private async step2Validation () {
        let error = undefined

        if (this.state.altriSinistri === undefined) {
            error = 'SINISTRI'
        }
        else if (this.state.polizzaAttiva === undefined) {
            error = 'POLIZZA'
        }
        else if (
            this.state.polizzaAttiva === true && 
            isNotValidScadenzaPolizza(this.state.scadenzaPolizza)
        ) {
            error = 'SCADENZA_POLIZZA'
        }
        else if (!isValid(this.state.dispositiviConnessi, DEVICES_PATTERN)) {
            error = 'DISPOSITIVI'
        }
        else if (this.state.acquistiOnline === undefined) {
            error = 'ACQUISTI'
        }
        else if (!isValidPrivacy(this.state.noMotorPrivacy, this.state.user !== undefined)) {
            error = 'PRIVACY'
        }
        else {
            await authFetch (
                STEP_2_VALIDATION_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        specificData: this.getSpecificDataForSubmit(),
                        privacy: getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),
                        isLogged: this.state.expiredSessionError === false ? this.state.user !== undefined : false
                    })
                },
                this.manageExpiredSessions,
            ).then ( jsonObj => {
                if (jsonObj.status > 200) {
                    error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                }
            }).catch( error => {
                error = CONNECTION_ERROR
            })
        }

        this.printError(error)

        return error
    }


}

const mapState = (state: any) => {
    return {
        contractor: state.contractor,
        altriSinistri: state.altriSinistri,
        polizzaAttiva: state.polizzaAttiva,
        scadenzaPolizza: state.scadenzaPolizza,
        rilevanza: state.rilevanza,

        dispositiviConnessi: state.dispositiviConnessi,
        acquistiOnline: state.acquistiOnline,

        actualPage: state.actualPage,

        noMotorPrivacy: state.noMotorPrivacy,
        user: state.user
    }
}


//export default CyberPage
export default connect(mapState) (CyberPage)